angular.module('dpw.services').constant('botEnvKeys', {
    PROD: 'prod'
});
